import React from 'react';
import { BrowserRouter as Router, Route, Link } from 'react-router-dom';
import SocioData from '../../services/socio-service';
import './sociogram.css';
import toast from 'react-hot-toast';

export class ListSociograms extends React.Component {

  constructor() {
    super()
    this.state = {}
  }

  async componentDidMount() {
    try {
      const self = this;
      const { accessToken } = this.props;
      const list = await SocioData.getSociogramList(accessToken);
      this.setState({ 
        data: list,
        accessToken,
        principal: JSON.parse(atob(accessToken.split(".")[1])).sub // gets the sub from the access token
      });
    } catch ( error ) {
      console.error(error)
      this.setState({
        error: true
      });
    }
    
    
    // SocioData.getSociogramList(function (err,data) {
    //   if( err ){
    //     self.setState({ 
    //       error: true 
    //     });
    //   }else{
    //     console.log("Data: " + JSON.stringify(data));
    //     self.setState({ 
    //       data: data,
    //       principal: JSON.parse(atob(localStorage.getItem('access_token').split(".")[1])).sub // gets the sub from the access token
    //     });
    //   }
    // });
  }

  handleGroupSizeChange = event => {
    if( isNaN(event.target.value) ) {
      event.target.value = this.state.groupSize;
      return;
    }
    this.setState({
      groupSize: event.target.value
    });
  }

  delete = async (id) => {
    if ( confirm("Are you sure you want to delete this sociogram?") ) {
      try {
        const response = await SocioData.deleteSociogram(id, this.state.accessToken);
        toast.success(response);
      } catch (error) {
        toast.error("Failed to delete sociogram");
      }
      
    }
  }

  render() {
    let data = this.state.data;

    let rows = [];
    var personCount = 0;

    if( !this.state.data ){
      return (<div>
        <h1>No Sociogram Available</h1>
        <Link to="/create">
            <button
              className="btn btn-primary btn-block contact">
              Create New Sociogram
            </button>
        </Link>
      </div>);
    }
    for (var i=0; i < data.length; i++) {
      var socioLink = "/sociogram/" + data[i].id;
      var groupLink = "/groups/" + data[i].id + "/" + this.state.groupSize;

      // only count people if people are configured for the sociogram
      var personCount = 0;
      if( data[i].people )
        personCount = data[i].people.length;


      rows.push(<tr>
        <td>
          <Link to={socioLink}>
            {data[i].name}
          </Link>
        </td>
        <td>
          <Link to={groupLink}>
            Generate Groups
          </Link>
        </td>
        <td>
          {data[i].created}
        </td>
        <td>
          {personCount}
        </td>
        <td>
          https://dev.hypersocio.com/entry/{data[i].id}/{this.state.principal}
        </td>
        <td>
          <button
            type="button"
            onClick={this.delete.bind(this, data[i].id)}
            className="btn btn-primary btn-block contact">
            Delete
          </button>
        </td>
      </tr>);
      personCount++;
    }

    return (
      <div>
        <h1>Previous Sociogram:</h1>
        <Link to="/create">
            <button
              className="btn btn-primary btn-block contact">
              Create New Sociogram
            </button>
        </Link>
        |
            Options: Group Size <input type="text" className="group-size" id="groupSize" name="groupSize" value={this.state.groupSize} onChange={this.handleGroupSizeChange} />
        <br />
        <br />
        <table>
          <tbody>
            <tr>
              <td>Name</td>
              <td>Generate Groups</td>
              <td>Created</td>
              <td>Number of people</td>
              <td>Public Website</td>
              <td>Delete Sociogram</td>
            </tr>
            {rows}
          </tbody>
        </table>
      </div>
    );
  }

  filterUsers(user,data){
    console.log("Filtering for user: " + user);
    return data.filter(
      function(data){ return data.personID == user }
    );
  }
}


